import { useState } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import { Character, UserInfo } from '~/components/MyPage';
import { EditNameBottomSheet, HelmetHead } from '~/components/common';
import BottomSheetContainer from '~/components/common/BottomSheet/BottomSheet';
import { fetchChangeNickName } from '~/api';
import { ChangeNickNameRequest } from '~/types/api';
import { useUserStore } from '~/store';

export default function MyPage() {
  const email = useUserStore((state) => state.email);
  const defaultNickName = useUserStore((state) => state.nickname);
  const setUser = useUserStore((state) => state.setUser);

  const [nickName, setNickName] = useState(defaultNickName);
  const [isOpen, setIsOpen] = useState(false);
  const nickNameDisabled =
    nickName === defaultNickName || nickName.trim().length === 0;

  const changeNickName = async () => {
    try {
      const requestData: ChangeNickNameRequest = {
        nickname: nickName,
      };
      const { status } = await fetchChangeNickName(requestData);

      if (status === 200) {
        setIsOpen(false);
        setUser({ nickname: nickName });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <HelmetHead title='My Page' />

      <Container>
        <UserInfo isOpen={isOpen} setIsOpen={setIsOpen} />
        <Character />
      </Container>

      <BottomSheetContainer isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <EditNameBottomSheet
          title={'User name'}
          desc={
            'Username will be displayed everywhere except in Character Creator tag.'
          }
          placeholder={defaultNickName}
          text={nickName}
          setText={setNickName}
          disabled={nickNameDisabled}
          onClick={changeNickName}
        />
      </BottomSheetContainer>
    </>
  );
}

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    padding: ${theme.layout.chat_header_height} 16px
      calc(${theme.layout.chat_navigation_height} + 30px);
  `}
`;

export const CardList = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
`;
